import React from 'react'
export const gno_circle_color = {
  path: (
    <>
      <path
        d="M16.0001 29.3334C23.3639 29.3334 29.3334 23.3639 29.3334 16.0001C29.3334 8.63628 23.3639 2.66675 16.0001 2.66675C8.63628 2.66675 2.66675 8.63628 2.66675 16.0001C2.66675 23.3639 8.63628 29.3334 16.0001 29.3334Z"
        fill="url(#paint0_linear_12683_845)"
        key="LJVog0mFo"
      />
      <path
        d="M22.6879 11.8684L22.0797 12.4766C22.5631 13.2368 22.7152 14.1903 22.3838 15.1017C21.831 16.6493 20.1181 17.4649 18.5564 16.9121C18.335 16.8295 18.1284 16.7328 17.9483 16.608L15.9999 18.5564L14.3002 16.8427C13.5128 17.3674 12.5039 17.5194 11.5504 17.1881C9.94736 16.608 9.11859 14.853 9.69864 13.264C9.78127 13.0153 9.90604 12.7939 10.044 12.5873L9.31194 11.8552L9.17395 12.0899C8.41377 13.3335 7.9998 14.7704 7.9998 16.2486C7.98575 20.656 11.5784 24.2628 15.9859 24.2628H15.9999C20.4073 24.2628 23.9868 20.6841 24 16.2759C24 14.8109 23.5993 13.3739 22.8391 12.1172L22.6879 11.8684Z"
        fill="white"
        key="k0Me0qxLQC"
      />
      <path
        d="M10.943 13.4855C10.7356 13.7615 10.6116 14.1077 10.6116 14.4804C10.6116 15.3786 11.3437 16.1107 12.2419 16.1107C12.6154 16.1107 12.9608 15.9859 13.2368 15.7653L10.943 13.4855ZM18.9431 15.6265C19.2059 15.8058 19.5099 15.9024 19.8553 15.9024C20.7535 15.9024 21.4856 15.1703 21.4856 14.2722C21.4856 13.9408 21.3889 13.6227 21.2096 13.3599L18.9431 15.6265ZM16.0271 17.3402L9.42261 10.7076L9.68537 10.4316C11.3156 8.70464 13.54 7.73706 15.9304 7.73706H15.9445C18.3622 7.73706 20.6841 8.77323 22.3003 10.5696L22.549 10.8456L16.0271 17.3402ZM10.5009 10.7076L16.028 16.2487L21.4856 10.8183C20.0206 9.35411 18.0309 8.51047 15.9585 8.51047H15.9445C13.8854 8.51047 11.9651 9.2847 10.5009 10.7076Z"
        fill="white"
        key="-CfWo2jbEV"
      />
      <linearGradient
        id="paint0_linear_12683_845"
        key="paint0_linear_12683_845"
        x1="7.50012"
        y1="6.00024"
        x2="25.5001"
        y2="29.0002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#001427" key="KIQDChEvjh" />
        <stop offset="1" stopColor="#003386" key="F4wxxbJ2i0" />
      </linearGradient>
    </>
  ),
  viewBox: '0 0 32 32',
}
